import Button from '@/components/atom/Button';
import LucideIcon from '@/components/atom/Icons/LucideIcon';
import Table from '@/components/atom/Table';
import Typo from '@/components/atom/Typo';
import MainContentTitle from '@/components/molecule/MainContentTitle';
import SectionCardNoneTitle from '@/components/molecule/SectionCardNoneTitle';
import { NAV_CONST } from '@/src/constants/nav';
import useAgGridHeaderRefresh from '@/hooks/useAgGridHeaderRefresh';
import { useEffect, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community/dist/lib/main';
import { noticeListColumn } from '@/src/pages/TestPage/TableTest/column';
import { useQuery } from '@tanstack/react-query';
import { getTestDataByPage } from '@/src/apis/rest/testRest';
import useDialog, { DialogType } from '@/hooks/useDialog';

const NOTICE_TABLE = {
  table: {
    titleKr: {
      en: 'Title (KR)',
      ko: '제목(한글)',
    },
    titleEn: {
      en: 'Title (EN)',
      ko: '제목(영문)',
    },
    isViewable: {
      en: 'Viewable',
      ko: '표기 여부',
    },
    adminName: {
      en: 'Adminstrator Name',
      ko: '등록 관리자',
    },
    id: {
      en: 'No.',
      ko: 'No.',
    },
    categoryType: {
      en: '유형',
      ko: '유형',
    },
    title: { en: '제목', ko: '제목' },
    createdAt: { en: '등록 일시', ko: '등록 일시' },
    showedYn: {
      en: '노출 여부',
      ko: '노출 여부',
    },
    fixedTopYn: {
      en: '우선 노출 여부',
      ko: '우선 노출 여부',
    },
    viewCount: {
      en: '조회 수',
      ko: '조회 수',
    },
  },
  label: {
    tableLabel: {
      en: 'Notice List',
      ko: '공지사항 목록',
    },
  },
};

function TableTestPage() {
  const gridRef = useRef<AgGridReact>(null);

  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const { Dialog, openDialog, closeDialog, isOpen } = useDialog({
    type: DialogType.ALERT,
  });

  const {
    data: noticeList,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['test', 'infinite'],
    queryFn: async () => await getTestDataByPage(page, pageSize),
  });

  const onPaginationChange = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const columnDefs: ColDef[] = noticeListColumn();
  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  useAgGridHeaderRefresh({
    gridRef: gridRef.current,
    isReady,
    headerSet: [
      {
        columnKey: 'titleKr',
        ko: NOTICE_TABLE.table.titleKr['ko'],
        en: NOTICE_TABLE.table.titleKr['en'],
      },
      {
        columnKey: 'titleEn',
        ko: NOTICE_TABLE.table.titleEn['ko'],
        en: NOTICE_TABLE.table.titleEn['en'],
      },
      {
        columnKey: 'createdAt',
        ko: NOTICE_TABLE.table.createdAt['ko'],
        en: NOTICE_TABLE.table.createdAt['en'],
      },
      {
        columnKey: 'updatedAt',
        ko: NOTICE_TABLE.table.adminName['ko'],
        en: NOTICE_TABLE.table.adminName['en'],
      },
      {
        columnKey: 'isViewable',
        ko: NOTICE_TABLE.table.isViewable['ko'],
        en: NOTICE_TABLE.table.isViewable['en'],
      },
    ],
  });
  return (
    <article className="pb-listBottomPadding">
      <MainContentTitle
        pageTitle={NAV_CONST.noticeManagement}
        breadcrumbList={[NAV_CONST.noticeManagement]}
      />

      <div className="flex flex-col gap-y-6">
        <SectionCardNoneTitle
          contentProps={{
            className: 'flex flex-col gap-y-4',
          }}
        >
          <div className="flex items-center justify-between">
            <Typo typoType="b18m">공지사항 목록</Typo>
            <Button buttonSize="medium" onClick={() => {}}>
              <div className="flex items-center gap-x-2">
                <LucideIcon name="Plus" color="white" />
                공지사항 등록
              </div>
            </Button>
            <Button buttonSize="medium" onClick={() => openDialog()}>
              알럿 테스트
            </Button>
          </div>

          <Table
            ref={gridRef}
            rowData={isError ? [] : noticeList}
            isPaginationDataMapping
            columnDefs={columnDefs}
            onGridReady={() => setIsReady(true)}
            total={10}
            page={page}
            pageSize={pageSize}
            handlePaginationClick={(page, pageSize) =>
              onPaginationChange({ page, pageSize })
            }
          />
        </SectionCardNoneTitle>
      </div>
      <Dialog title="test alert title" open={isOpen} onOpenChange={closeDialog}>
        테스트 알럿
      </Dialog>
    </article>
  );
}

export default TableTestPage;
